module.exports = __webpack_public_path__ + "static/media/empty-avatar.5759dd7f.svg";